/** Shop colors. Hippe stays the stylesheet default. Made for Moments follows the site, with #CB5796 as the accent. */
const MADE_FOR_MOMENTS: Record<string, string> = {
  '--aps-accent': '#CB5796',
  '--aps-accent-press': '#A6477B',
  '--aps-accent-soft': '#FBEFF5',
  '--aps-ink': '#1b1518',
  '--aps-muted': '#6a5f63',
  '--aps-line': '#e9e2e5',
  '--aps-cream': '#FBEFF5',
  '--aps-cta-border': '#F0CFE0',
  '--aps-cta-end': '#F0CFE0',
  '--aps-glow': '203, 87, 150',
  '--aps-progress': '#E3A3C4',
  '--aps-track': '#F6D7E8',
  '--aps-spinner': '#F6D7E8',
  '--aps-font': "'Be Vietnam Pro', Nunito, ui-rounded, system-ui, sans-serif",
  '--aps-heading': "SangBleuSunrise, 'Be Vietnam Pro', Georgia, serif",
};

/** Pretty Orange: site primary #c66d55, cream from the site, Poppins. */
const PRETTY_ORANGE: Record<string, string> = {
  '--aps-accent': '#c66d55',
  '--aps-accent-press': '#ac604b',
  '--aps-accent-soft': '#FFF4DD',
  '--aps-ink': '#2b2118',
  '--aps-muted': '#6d645c',
  '--aps-line': '#E6E6E6',
  '--aps-cream': '#FFF5EE',
  '--aps-cta-border': '#f0d3c8',
  '--aps-cta-end': '#FFF4DD',
  '--aps-glow': '198, 109, 85',
  '--aps-progress': '#e3b5a6',
  '--aps-track': '#f8e4dc',
  '--aps-spinner': '#f8e4dc',
  '--aps-font': "Poppins, Nunito, ui-rounded, system-ui, sans-serif",
  '--aps-heading': "Poppins, Nunito, Georgia, serif",
};

const SHOP_THEMES: Record<string, Record<string, string>> = {
  mfm: MADE_FOR_MOMENTS,
  'po-fr': PRETTY_ORANGE,
  'po-de': PRETTY_ORANGE,
};

export function applyShopTheme(host: HTMLElement, shopId: string | undefined): void {
  const theme = shopId ? SHOP_THEMES[shopId] : undefined;
  if (!theme) return;
  for (const [name, value] of Object.entries(theme)) host.style.setProperty(name, value);
}
